
import { useCustomCalcResultStore } from '@/shared/service';
import { Component, Vue } from 'vue-property-decorator';
import { SettingQoutAllConditions } from '../settingQoutAllConditions';
import { SettingRainfallConditions } from '../settingRainfallConditions';
import { CustomDamPrediction } from '../customDamPrediction';
import { CustomCalculationView } from '../../model';

@Component({
  components: {
    SettingQoutAllConditions,
    SettingRainfallConditions,
    CustomDamPrediction,
  },
})
export default class CustomCalculation extends Vue {
  currentView: CustomCalculationView = CustomCalculationView.SettingRainfallConditions;

  /**
   * 手動計算のファイル名(拡張子無し)
   */
  manualCalculationFileName: string | null = null;

  /**
   * 手動計算専用の対象時刻
   */
  customTargetTime: string = this['$store'].getters.targetTime || '';

  /**
   * 手動計算専用の観測所ID
   */
  customStationId = '';

  /**
   * 放流量条件設定で通常予測結果ZIPを入力源とするかどうか
   * （降雨条件設定をスキップして放流量だけ編集するフロー時に true）
   */
  useNormalPredictionResult = false;

  get isSettingRainfallConditionsView() {
    return this.currentView === CustomCalculationView.SettingRainfallConditions;
  }

  get isRainfallResultView() {
    return this.currentView === CustomCalculationView.RainfallResult;
  }

  get isSettingQoutAllConditionsView() {
    return this.currentView === CustomCalculationView.SettingQoutAllConditions;
  }

  get isQoutAllResultView() {
    return this.currentView === CustomCalculationView.QoutAllResult;
  }

  get isSavedResultView() {
    return this.currentView === CustomCalculationView.SavedResult;
  }

  get CustomCalculationView() {
    return CustomCalculationView;
  }

  private customCalcResultStore = useCustomCalcResultStore();

  get basinId() {
    return this['$store'].getters.basinId;
  }

  mounted() {
    // 手動計算画面専用のtargetTimeとstationIdをstoreの値で初期化
    this.customTargetTime = this['$store'].getters.targetTime || '';
    this.customStationId = this['$store'].getters.stationId || '';
  }

  setManualCalculationFileName(fileName: string) {
    this.manualCalculationFileName = fileName;
  }

  setCustomTargetTime(value: string) {
    this.customTargetTime = value;
  }

  setCustomStationId(value: string) {
    this.customStationId = value;
    if (!this.manualCalculationFileName) {
      return;
    }
    if (this.currentView === CustomCalculationView.RainfallResult || this.currentView === CustomCalculationView.QoutAllResult) {
      this.customCalcResultStore.fetch(this.basinId, this.customStationId, this.manualCalculationFileName);
    }
  }

  // 降雨条件計算実行
  onCalculationExecutedRainfall() {
    if (!this.manualCalculationFileName) {
      return;
    }
    this.useNormalPredictionResult = false;
    this.customCalcResultStore.fetch(this.basinId, this.customStationId, this.manualCalculationFileName);
    this.currentView = CustomCalculationView.RainfallResult;
  }

  // 降雨条件設定をスキップして放流量条件設定へ移動（通常予測結果ZIPを入力源とする）
  onSkipToQoutAll(): void {
    this.useNormalPredictionResult = true;
    this.manualCalculationFileName = null;
    this.currentView = CustomCalculationView.SettingQoutAllConditions;
  }

  onCalculationExecutedQoutAll() {
    if (!this.manualCalculationFileName) {
      return;
    }
    this.customCalcResultStore.fetch(this.basinId, this.customStationId, this.manualCalculationFileName);
    this.currentView = CustomCalculationView.QoutAllResult;
  }

  // 放流条件設定へ移動
  onMoveToSettingQoutAllConditions(): void {
    this.currentView = CustomCalculationView.SettingQoutAllConditions;
  }

  // 降雨条件設定へ移動
  onBackToRainfall(): void {
    this.currentView = CustomCalculationView.SettingRainfallConditions;
  }

  // 保存済み結果へ移動
  onMoveToSavedResult(): void {
    this.currentView = CustomCalculationView.SavedResult;
  }

  // 降雨条件設定へ移動
  onMoveToSettingRainfall(): void {
    this.currentView = CustomCalculationView.SettingRainfallConditions;
  }
}
